import * as React from "react";
import { HStack, Button } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { Form, TextInput } from "components";
import { casesActions } from "configs";
import { useDispatch, useCurrentCase } from "duck";
import { useUpdateMedicalCaseMutation } from "requests";
import { VALIDATION_SCHEMA } from "./duck";

interface NameFormProps {
  defaultName: string;
  onFinish(): void;
}

const NameForm: React.FC<NameFormProps> = ({ defaultName, onFinish }) => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const [update] = useUpdateMedicalCaseMutation();

  const shouldSync = useCurrentCase(pendingCase => pendingCase.shouldSync);

  return (
    <Form
      validationSchema={VALIDATION_SCHEMA}
      defaultValues={{ name: defaultName }}
      onSubmit={values => {
        dispatch(
          casesActions.updateCaseName({
            _id: id as string,
            data: values.name
          })
        );

        onFinish();

        if (shouldSync) {
          return update({
            variables: { input: { _id: +(id as string), name: values.name } }
          });
        }
      }}
    >
      <HStack spacing={4}>
        <TextInput
          size="md"
          name="name"
          label="Case name"
          labelHidden
          inputLayoutProps={{
            errorProps: { position: "absolute", marginTop: "4px" }
          }}
        />
        <Form.Controls
          spacing={2}
          submitProps={{ size: "xs" }}
          submitText="Save"
        >
          <Button
            size="xs"
            variant="outline"
            colorScheme="gray"
            onClick={onFinish}
          >
            Cancel
          </Button>
        </Form.Controls>
      </HStack>
    </Form>
  );
};

export default NameForm;
